import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * "Saved ✓" success confirmation (#5830 / #5347). Shown in place of the SaveChangesButton right
 * after a successful save (mutually exclusive with it, never beside it) so the explicit-save flow
 * gives clear feedback. Save failures surface as an error toast from the caller's mutation, not here
 * (success is never a toast per the design system).
 */
export function SavedIndicator({ className, label = 'Saved' }: { className?: string; label?: string }) {
  return (
    <span className={cn('flex h-9 items-center gap-1 pr-2 text-sm text-[#047857]', className)}>
      <Check className="h-4 w-4" />
      {label}
    </span>
  );
}
